import { useEffect } from 'react';
import { COLORS } from '@hyphengroup/cag-components';
import {
  loginDashboardPromotionalCard,
  loginDashboardPromotionalCardSwipe,
  loginDashboardPromotionalCardLoad,
} from 'components/tracking';
import { dashboardPromotionalsChooseQuizCtaClickEvent } from 'components/tracking/DashboardQuizTrackingUtils';
import { dashboardModules } from 'helpers/dashboardCommonUtils';
import { validatePromotionsData } from 'components/dashboard/dashboardUtils';

function getPromotionsModule({
  promotionsData, track, staticText, setShowQuizSelectionModal,
}) {
  return ({
    id: dashboardModules.PROMOTIONS,
    type: 'slider',
    menuTitle: staticText.DASHBOARD_PROMOTIONS_TITLE,
    promotions: {
      onSlideChange: (activeSlide) => {
        loginDashboardPromotionalCardSwipe(
          track,
          promotionsData[activeSlide],
        );
      },
      data: promotionsData
        .map((promotion) => (
          promotion.quizList ? {
            header: promotion.header,
            subheader: promotion.description,
            cta: {
              text: promotion.selectQuizLabel,
              onClick: () => {
                setShowQuizSelectionModal(true);
                dashboardPromotionalsChooseQuizCtaClickEvent(track);
              },
            },
            image: {
              link: promotion.image.url,
              alt: promotion.image.filename,
            },
            backgroundColor: COLORS.GRAD_01,
            template: 'Promo_Template_Icon_Cropped',
          } : {
            header: promotion.header,
            subheader: promotion.shortDescription,
            cta: {
              text: promotion.cta.title,
              onClick: () => {
                loginDashboardPromotionalCard(track, promotion);
                const win = window.open(promotion.cta.href, '_blank');
                win.focus();
              },
            },
            image: {
              link: promotion.image?.url,
              alt: promotion.image?.filename,
            },
            backgroundColor: promotion.cardVisualControl.backgroundColourType,
            template: promotion.cardVisualControl.templateType,
          })),
    },
  });
}

const usePromotions = (props) => {
  const {
    promotions, track,
  } = props;
  const promotionsData = validatePromotionsData(promotions);

  useEffect(() => {
    if (promotionsData) {
      promotionsData.forEach(promotion => loginDashboardPromotionalCardLoad(track, promotion));
    }
  }, [promotions]);

  const promotionsModule = promotionsData
    ? getPromotionsModule({ promotionsData, ...props })
    : null;

  return promotionsModule;
};

export default usePromotions;
